import { all, call, put, takeLatest } from "redux-saga/effects";
import { GET_LIST_CHECKTHONGTINKH } from "actions/CheckThongTinKh/actionTypes";
import {
  getListCheckThongTinKhSuccess,
  getListCheckThongTinKhFailure,
} from "actions/CheckThongTinKh";
import CheckThongTinKhApi from "service/danhSachKhachHangApi";
import { pushNotification } from "utils/notifications";

function* getListCheckThongTinKh(action) {
  try {
    const response = yield call(CheckThongTinKhApi.list, action.dataSearch);
    if (response.ok) {
      yield put(getListCheckThongTinKhSuccess(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(getListCheckThongTinKhFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(getListCheckThongTinKhFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_LIST_CHECKTHONGTINKH, getListCheckThongTinKh);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
